import './_property-reviews-panel.js';
import './_latest-cottages-slider.js';
import './_main.js';
import './_Gallery.js';
